export const COMPLAINT_GRIEVANCES = "/grievances";
export const GRIEVANCES_SEARCH = "/grievances/search"
export const COMPLAINT_SEARCH = "/complaints/search"
export const EMPLOYEES_SEARCH = "/employees/search"
export const EMPLOYEES_GetExportList = "/complaints/GetExportList"
export const CLIENT_REVIEW = "/grievances/clientreview"
export const CLIENTS = "/clients"
export const COMPLAINT_MULTI = "/complaints/multi"
export const LEGAL_SEARCH = "/Legal/search"
export const LEGAL_STATUS ="/Legal/Status"
export const LEGAL_CASETYPES ="/Legal/CaseTypes"
export const REPORT_CONFIGURATION_CLIENTS = "/ReportConfiguration/clients"
export const REPORT_CONFIGURATION_LOOKUPS = "/ReportConfiguration/lookups"
export const REPORT_CONFIGURATION_DATA_MODELS = "/ReportConfiguration/data-models"
export const REPORT_CONFIGURATION_RULE_OPERATORS = "/ReportConfiguration/rule-operators"
export const REPORT_CONFIGURATION_EXCEL_LAYOUT_TEMPLATES = "/ReportConfiguration/excel-layout-templates"
export const REPORT_CONFIGURATION_REPORT_PLAN = "/ReportConfiguration/clients"
export const REPORT_CONFIGURATION_REPORT_FOLDERS = "/ReportConfiguration/report-folders"
export const REPORT_CONFIGURATION_REPORTS = "/ReportConfiguration/reports"
export const REPORT_CONFIGURATION_CONFIG_VERSIONS = "/ReportConfiguration/config-versions"
export const REPORT_CONFIGURATION_MEMBER_SEARCH = "/ReportConfiguration/member-search"
export const REPORT_CONFIGURATION_MEMBER = "/ReportConfiguration/member"
export const REPORT_CONFIGURATION_REPORT_WORKBOOK = "/ReportConfiguration/reports"
